export default function PrivacyModal({ t, onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '600px'}}>
        <button className="modal-close" onClick={onClose} id="privacy-modal-close">×</button>
        <div className="modal-header-icon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
        </div>
        <h3 className="modal-title">{t.privacyTitle}</h3>
        <div className="privacy-content">
          <p>{t.privacyText}</p>
        </div>
        <button className="btn-primary" style={{marginTop: '30px', width: '100%', justifyContent: 'center'}} onClick={onClose} id="privacy-understood-btn">
          Understood
        </button>
      </div>
    </div>
  );
}
